module.exports = __webpack_public_path__ + "img/edit02.6e7b515d.jpg";